import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Translator } from '../translator.type';

export type Agency = {
  countCircuits?: number;
  id: string;
  name: string;
  createdAt: string;
  city: string;
  country: string;
  allReceiverCircuits?: number;
  shouldShareAllFutureCircuits: boolean;
};

export type NetworkWithAgencies = {
  id: string;
  name: string;
  createdAt: string;
  _count: {
    Agency: number;
  };
};

export const NETWORK_COLUMNS = (
  t: Translator,
): ColumnDef<NetworkWithAgencies>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: t('distributors.columns.name'),
  },
  {
    accessorKey: '_count.Agency',
    header: t('distributors.columns.agenciesCount'),
  },
  {
    accessorKey: 'createdAt',
    header: t('distributors.columns.createdAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
    enableSorting: false,
  },
];

export const AGENCY_COLUMNS = (t: Translator): ColumnDef<Agency>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllRowsSelected() ||
          (table.getIsSomeRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: t('distributors.columns.name'),
  },
  {
    accessorKey: 'city',
    header: t('distributors.columns.city'),
  },
  {
    accessorKey: 'country',
    header: t('distributors.columns.country'),
  },
  {
    accessorKey: 'countCircuits',
    header: t('distributors.columns.proposedCircuits'),
    cell: ({ row }) =>
      row.original.countCircuits !== undefined ? (
        <span>{`${row.original.countCircuits}/${row.original.allReceiverCircuits}`}</span>
      ) : (
        <span>-/-</span>
      ),
  },
  {
    accessorKey: 'createdAt',
    header: t('distributors.columns.createdAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
  },
];
